import { Vault } from 'nftx.js';
import { useQuery } from '@tanstack/react-query';
import checkImageExists from '../utils/checkImageExists';
import getVaultIcon from '../utils/getVaultIcon';
import { QueryKey } from '@/application/queryKeys';

export default function useVaultIcon(
  network: number,
  vaultId?: Vault['vaultId'],
  legacy?: boolean // V2 vaults
) {
  return useQuery(
    [QueryKey.VAULT_ICON, network, vaultId, legacy],
    async () => {
      if (vaultId) {
        const vaultIconPath = getVaultIcon(vaultId, network, legacy);
        const exists = await checkImageExists(vaultIconPath);

        if (exists) {
          return vaultIconPath;
        }
      }

      return undefined;
    },
    {
      enabled: vaultId != null,
      cacheTime: Infinity,
      staleTime: Infinity,
    }
  );
}
